import { Mail, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";

export const Contact = () => (
  <section className="bg-ink border-t border-white/8 py-20 sm:py-28" data-testid="contact-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div className="max-w-xl">
            <Eyebrow>Not Ready for the Portal Yet?</Eyebrow>
            <h2 className="font-display text-3xl sm:text-4xl text-cream tracking-tight leading-[1.1] mt-5">
              Email Me <em className="text-gold italic">Directly.</em>
            </h2>
            <p className="text-cream/65 leading-relaxed mt-4 text-sm sm:text-base">
              No forms. No pressure. Send me your questions and I will answer them personally. When you are
              ready, the portal will be right here waiting.
            </p>
          </div>
          <a
            href="mailto:support@igcfirm.com"
            data-testid="contact-email-btn"
            className="group inline-flex items-center justify-center gap-3 border border-gold/50 text-gold font-semibold tracking-[0.08em] text-sm sm:text-base px-8 py-4 rounded-full hover:bg-gold hover:text-ink transition-colors duration-300 w-fit"
          >
            <Mail size={17} />
            support@igcfirm.com
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1.5" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
